import type { AbGroup, AbTestingState } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: AbTestingState = {
  group: null,
};

const abTestingStore = createSlice({
  name: 'abTesting',
  initialState,
  reducers: {
    setAbGroup: (state, action: PayloadAction<AbGroup>) => {
      state.group = action.payload;
    },
  },
});

export const { setAbGroup } = abTestingStore.actions;

export default abTestingStore;
